import { useQuery } from '@tanstack/react-query'
import { useLocation } from 'react-router-dom'
import { useUserContext } from 'shared/hooks/useUserContext'

import { productUpdatesApi } from '../..'
import { SuccessResponse } from '../../productUpdateTypes'
import { GetNewProductUpdatesResponse } from './getNewUpdates.types'

export const UNACKNOWLEDGED_UPDATES_QUERY_KEY = 'UNACKNOWLEDGED_UPDATES'

export const getNewProductUpdates = async () => {
  const response = await productUpdatesApi.get<
    SuccessResponse<GetNewProductUpdatesResponse[]>
  >('/me/pending-acknowledgements')
  return response?.data?.data
}

export const useNewProductUpdatesQuery = () => {
  const location = useLocation()
  const { user } = useUserContext()
  return useQuery({
    queryKey: [UNACKNOWLEDGED_UPDATES_QUERY_KEY, location.pathname, user?.id],
    queryFn: getNewProductUpdates,
    enabled: !!user,
    staleTime: 0,
    refetchOnWindowFocus: true
  })
}
